import { StoresRepository } from '~repositories/StoresRepository';
import { FindInStore } from '~domain/entities/FindInStore';
import { UserLocation } from '~domain/entities/UserLocation';
import { diContainer } from '~setup/diContainer';
import serviceNames from '~setup/StoresService';

export class SeeAvailabilityUseCase {
    private storesRepository: StoresRepository;
    private findInStore: FindInStore;
    private searchLocation: UserLocation;

    constructor(searchLocation: UserLocation) {
        this.searchLocation = searchLocation;
        this.storesRepository = diContainer.get(serviceNames.storesRepository);
        this.findInStore = diContainer.get(serviceNames.findInStore);
    }

    public execute = async () => {
        await this.storesRepository.loadBOPISInventoryByCoords(
            this.findInStore.skuBaseId,
            this.searchLocation.geolocation
        );

        return this.storesRepository.stores && this.storesRepository.stores.length;
    };
}
